import type { SupportedLocale } from '../types/simulation'
import translations from './studio-quick-start-ideas.json'
import onboardingLabels from './onboarding-idea-labels.json'

export const studioQuickStartIdeas: Record<SupportedLocale, readonly string[]> = translations
export const onboardingIdeaLabels: Record<SupportedLocale, readonly string[]> = onboardingLabels

export const studioQuickStartIdeasLabel: Record<SupportedLocale, string> = {
  tr: 'Örnek istekler', en: 'Example requests', de: 'Beispielanfragen',
  es: 'Solicitudes de ejemplo', fr: 'Exemples de demandes', ru: 'Примеры запросов',
  it: 'Richieste di esempio', pt: 'Pedidos de exemplo', sv: 'Exempel på önskemål',
  nl: 'Voorbeeldverzoeken', ar: 'أمثلة على الطلبات', hi: 'उदाहरण अनुरोध',
  id: 'Contoh permintaan', ja: 'リクエスト例', ko: '요청 예시',
  pl: 'Przykładowe prośby', th: 'ตัวอย่างคำขอ',
}

export const studioPremiumPlaceholder: Record<SupportedLocale, string> = {
  tr: 'Premium görseller üret', en: 'Create premium images', de: 'Premium-Bilder erstellen',
  es: 'Crea imágenes premium', fr: 'Créez des images premium', ru: 'Создавайте премиальные изображения',
  it: 'Crea immagini premium', pt: 'Cria imagens premium', sv: 'Skapa premiumbilder',
  nl: 'Maak premiumafbeeldingen', ar: 'أنشئ صورًا مميزة', hi: 'प्रीमियम चित्र बनाएँ',
  id: 'Buat gambar premium', ja: 'プレミアムな画像を作成', ko: '프리미엄 이미지 만들기',
  pl: 'Twórz obrazy premium', th: 'สร้างภาพระดับพรีเมียม',
}

export const studioIdeasOnboardingCopy: Record<SupportedLocale, { title: string; body: string }> = {
  tr: { title: 'Bir cümleyle.', body: 'Fikrini yaz. Gerisini Voxnela’ya bırak.' },
  en: { title: 'Just one sentence.', body: 'Write your idea. Let Voxnela do the rest.' },
  de: { title: 'Ein Satz genügt.', body: 'Schreib deine Idee. Voxnela erledigt den Rest.' },
  es: { title: 'Una sola frase.', body: 'Escribe tu idea. Voxnela hace el resto.' },
  fr: { title: 'Une seule phrase.', body: 'Écrivez votre idée. Voxnela fait le reste.' },
  ru: { title: 'Всего одна фраза.', body: 'Опишите идею. Остальное сделает Voxnela.' },
  it: { title: 'Basta una frase.', body: 'Scrivi la tua idea. Al resto pensa Voxnela.' },
  pt: { title: 'Uma só frase.', body: 'Escreve a tua ideia. A Voxnela faz o resto.' },
  sv: { title: 'En enda mening.', body: 'Skriv din idé. Voxnela gör resten.' },
  nl: { title: 'Eén zin is genoeg.', body: 'Schrijf je idee. Voxnela doet de rest.' },
  ar: { title: 'بجملة واحدة.', body: 'اكتب فكرتك. واترك الباقي لـ Voxnela.' },
  hi: { title: 'बस एक वाक्य।', body: 'अपना विचार लिखें। बाकी Voxnela पर छोड़ दें।' },
  id: { title: 'Cukup satu kalimat.', body: 'Tulis idemu. Voxnela mengerjakan sisanya.' },
  ja: { title: 'ひとことで。', body: 'アイデアを書いて、あとはVoxnelaにおまかせ。' },
  ko: { title: '한 문장이면 충분해요.', body: '아이디어를 적으세요. 나머지는 Voxnela가 할게요.' },
  pl: { title: 'Wystarczy jedno zdanie.', body: 'Opisz swój pomysł. Resztą zajmie się Voxnela.' },
  th: { title: 'เพียงประโยคเดียว', body: 'เขียนไอเดียของคุณ แล้วให้ Voxnela ทำส่วนที่เหลือ' },
}

export function pickStudioQuickStartIdeas(random: () => number = Math.random): number[] {
  const indexes = Array.from({ length: studioQuickStartIdeas.tr.length }, (_, index) => index)
  for (let index = indexes.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1))
    const selected = indexes[index]!
    indexes[index] = indexes[swapIndex]!
    indexes[swapIndex] = selected
  }
  return indexes.slice(0, 8)
}
